import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ user }) => {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    {
      title: 'Dashboard',
      icon: '📊',
      path: '/dashboard',
      roles: ['admin', 'operator']
    },
    {
      title: 'Vehicles',
      icon: '🚛',
      path: '/vehicles',
      roles: ['admin', 'operator']
    },
    {
      title: 'Trips',
      icon: '🗺️',
      path: '/trips',
      roles: ['admin', 'operator']
    },
    {
      title: 'Plants',           // ← NEW
      icon: '📍',               // or 🏭 / 🌳 / 📍 / etc.
      path: '/plants',
      roles: ['admin', 'operator']
    },
    /* {
      title: 'Excel Upload',
      icon: '📈',
      path: '/excel-upload',
      roles: ['admin', 'operator']
    }, */
    {
      title: 'Reports',
      icon: '📋',
      path: '/reports',
      roles: ['admin']
    },
    {
      title: 'Settings',
      icon: '⚙️',
      path: '/settings',
      roles: ['admin']
    }
  ];

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Filter menu items based on user role
  const filteredMenuItems = menuItems.filter(item => 
    item.roles.includes(user?.role)
  );

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-toggle" onClick={toggleSidebar}>
        <span>{isCollapsed ? '→' : '←'}</span>
      </div>

      <div className="sidebar-header">
        <div className="sidebar-logo">
          <span className="logo-icon">📊</span>
          {!isCollapsed && <span className="logo-text">Operations</span>}
        </div>
      </div>

      <div className="sidebar-menu">
        {filteredMenuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => 
              `menu-item ${isActive || location.pathname === item.path ? 'active' : ''}`
            }
            title={item.title}
          >
            <span className="menu-icon">{item.icon}</span>
            {!isCollapsed && <span className="menu-text">{item.title}</span>}
          </NavLink>
        ))}
      </div>

      <div className="sidebar-footer">
        {!isCollapsed && (
          <div className="user-profile">
            <div className="profile-avatar">
              {user?.full_name?.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) || 'U'}
            </div>
            <div className="profile-info">
              <div className="profile-name">{user?.full_name || user?.username}</div>
              <div className="profile-role">{user?.role?.toUpperCase()}</div>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
